import {
  Card,
  Divider,
  Grid,
  Snackbar,
  Typography,
  Button,
  Alert as MuiAlert,
  Pagination,
  Box,
  CardContent,
  Chip,
  Avatar,
  TextField
} from '@mui/material'
import { Add as AddIcon, Edit as EditIcon } from '@mui/icons-material'
import MainCard, {
  SnackBarHideDuration,
  SnackBarTransition,
  ShowNoRecordsFound,
  stringAvatar,
  ErrorScreen
} from '../../utils/ui_utils'
import { useEffect, useState, forwardRef } from 'react'
import { Helmet } from 'react-helmet-async'
import { businessCheck } from '../../utils/utils'
import UserDialog from '../user/user/userDialog'
import UserInfoDialog from '../user/user/userInfoDialog'
import EditMobileDialog from '../user/user/editUserMobileNumber'
import UserTypeShimmer from '../../utils/ui_components/shimmers/userTypeShimmer'
import {
  useCreateUser,
  useFetchUserForFranchise,
  useSendAdminOtp,
  useUpdateUser,
  useVerifyAdminOtp
} from '../../modules/user/userHooks'
import _ from 'lodash'
import { useFetchOutlet } from '../../modules/outlet/outletHooks'

const FranchiseUsers = function () {
  const [error, setError] = useState(null)
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(10)
  const [pagecount, setPageCount] = useState(1)
  const [goToPageInput, setGoToPageInput] = useState('')
  const [snackbar, setSnackBar] = useState(false)
  const [PopUpMessage, setPopUpMessage] = useState(null)
  const [severity, setSeverity] = useState(null)
  const [userDialogVisibility, setUserDialogVisibility] = useState(false)
  const [userInfoDialogVisibility, setUserInfoDialogVisibility] =
    useState(false)
  const [userDialogMode, setUserDialogMode] = useState('edit')
  const [userdata, setUserData] = useState(undefined)
  const [showOtpUI, setShowOtpUI] = useState(false)
  const { userFetch, userFetchData, userFetchError, userFetchloading } =
    useFetchUserForFranchise()
  const { userCreate, userCreateloading } = useCreateUser()
  const { userUpdate, userUpdateloading } = useUpdateUser()
  const { userSendAdminOtp, userSendOtploading } = useSendAdminOtp()
  const { userVerifyAdminOtp, userVerifyOtploading } = useVerifyAdminOtp()
  const [showEditMobileDialog, setShowEditMobileDialog] = useState(false)
  const handleSnackbarClose = () => {
    setSnackBar(false)
  }
  const { outletFetch } = useFetchOutlet()
  const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
  })

  const toastMessage = (message, severity) => {
    setPopUpMessage(message)
    setSeverity(severity)
    setSnackBar(true)
  }

  const handlePageChange = async (event, value) => {
    setPage(value)
    let payload = {
      pageNumber: value,
      limit: limit
    }
    userFetch(payload)
  }

  const handleGoToPageChange = (event) => {
    const value = event.target.value
    if (/^\d+$/.test(value) || value === '') {
      setGoToPageInput(value)
    }
  }

  const handleGoToPageSubmit = () => {
    const pageNum = parseInt(goToPageInput, 10)
    if (pageNum >= 1 && pageNum <= pagecount) {
      handlePageChange(null, pageNum)
      setGoToPageInput('')
    }
  }

  const handleGoToPageKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleGoToPageSubmit()
    }
  }

  const pageCount = (data1) => {
    let count = Math.ceil(data1 / limit)
    setPageCount(count)
  }

  const sendOTP = (loginId) => {
    let requestOTP = { mobile: loginId }
    userSendAdminOtp(requestOTP, (success, error, message) => {
      if (error) {
        toastMessage(message, 'error')
      } else {
        toastMessage('OTP Sent', 'success')
        setShowOtpUI(true)
      }
    })
  }

  useEffect(() => {
    if (userFetchData.data?.length > 0) {
      pageCount(userFetchData?.total)
    }
  }, [userFetchData])

  useEffect(() => {
    businessCheck(history)
    let payload = {
      pageNumber: page,
      limit: limit
    }
    userFetch(payload)
    payload = {
      pageNumber: 1,
      limit: 100
    }
    outletFetch(payload)
  }, [])

  const fetchUsersOnError = () => {
    let payload = {
      pageNumber: page,
      limit: limit
    }
    userFetch(payload)
  }

  const UsersListUI = ({ users, index }) => (
    <MainCard
      sx={{
        mt: 1,
        p: 2,
        alignItems: 'center',
        transition: 'box-shadow 0.3s ease',
        borderRadius: 1,
        '&:hover': {
          boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.2)',
          backgroundColor: 'rgba(0, 0, 0, 0.04)'
        }
      }}
    >
      <Grid container spacing={1}>
        <Grid item sx={{ mr: 3 }}>
          <Avatar {...stringAvatar(users?.first_name)} />
        </Grid>
        <Grid item md sm>
          <Grid
            container
            sx={{ cursor: 'pointer' }}
            direction={'column'}
            onClick={() => {
              setUserDialogMode('edit')
              setUserDialogVisibility(true)
              setUserData(users)
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              {users?.first_name} {users?.last_name}
            </Typography>
            <Typography variant="body1" sx={{ color: 'text.secondary' }}>
              {users.user_type === 'User' ? 'Cashier' : users.user_type}
            </Typography>
            <Grid container direction={'row'}>
              {users?.outlet?.map((outlet, index) => (
                <Grid item key={index} pr={1}>
                  <Chip
                    size="small"
                    label={
                      outlet.name.length > 15 &&
                      outlet.sub_business_name.length > 15
                        ? outlet.name.slice(0, 15) +
                          '... | ' +
                          outlet.sub_business_name.slice(0, 15) +
                          '...'
                        : outlet.name.length > 15
                        ? outlet.name.slice(0, 15) +
                          '... | ' +
                          outlet.sub_business_name
                        : outlet.sub_business_name.length > 15
                        ? outlet.name +
                          ' | ' +
                          outlet.sub_business_name.slice(0, 15)
                        : outlet.name + ' | ' + outlet.sub_business_name
                    }
                    color="default"
                    variant="filled"
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
        <Grid item justifyContent={'flex-end'}>
          <Chip
            size="small"
            label={
              users.account_status === 'active'
                ? 'Active'
                : users.account_status === 'closed'
                ? 'Inactive'
                : users.account_status.capitalizeFirstLetter()
            }
            color={users.account_status === 'active' ? 'success' : 'error'}
          />{' '}
        </Grid>
      </Grid>
    </MainCard>
  )

  return (
    <>
      <Helmet title="Franchise Users" />
      <Grid
        container
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Grid item md={6}>
          <Typography variant="h4" gutterBottom display="inline">
            Franchise Users
          </Typography>
        </Grid>
        {!error && (
          <Grid item>
            <Button
              startIcon={<AddIcon />}
              variant="contained"
              size="small"
              color="primary"
              onClick={() => {
                setUserDialogMode('new')
                setUserDialogVisibility(true)
                setUserData(undefined)
                setShowOtpUI(false)
              }}
            >
              Add User
            </Button>
          </Grid>
        )}
      </Grid>
      <Grid>
        <Grid item>
          <div>
            <UserDialog
              loading={
                userCreateloading ||
                userUpdateloading ||
                userSendOtploading ||
                userVerifyOtploading
              }
              mode={userDialogMode}
              initialValues={_.cloneDeep(userdata)}
              title={userDialogMode == 'new' ? 'Create User' : 'Edit User'}
              okText={userDialogMode == 'new' ? 'Create' : 'Update'}
              visible={userDialogVisibility}
              showOTPui={showOtpUI}
              onResendOTP={(mobile) => {
                sendOTP(mobile)
              }}
              showOutletSelection={true}
              forFranchise={true}
              onSubmit={async (value) => {
                let values = _.cloneDeep(value)
                if (userDialogMode == 'new') {
                  if (!showOtpUI) {
                    sendOTP(values.mobile)
                  } else {
                    if (values.OTP.length < 4) return
                    let payload = {
                      mobile: values.mobile,
                      otp: values.OTP
                    }
                    await userVerifyAdminOtp(
                      payload,
                      async (success, error, message) => {
                        if (error) {
                          toastMessage(message, 'error')
                          return
                        } else {
                          toastMessage('OTP Verified', 'success')
                          values.role = values.user_type
                          delete values.confirmPassword
                          delete values.OTP
                          await userCreate(
                            values,
                            (success, error, message) => {
                              if (error) {
                                let errorMessage =
                                  message || 'User creation failed'
                                toastMessage(errorMessage, 'error')
                                setShowOtpUI(false)
                              } else {
                                toastMessage('User Created.', 'success')
                                setUserDialogVisibility(false)
                                setShowOtpUI(false)
                                setUserData(undefined)
                                let payload = {
                                  pageNumber: page,
                                  limit: limit
                                }
                                userFetch(payload)
                              }
                            }
                          )
                        }
                      }
                    )
                  }
                } else {
                  values.id = values._id
                  delete values._id
                  delete values.confirmPassword
                  delete values.password
                  delete values.OTP
                  delete values.key
                  await userUpdate(values, (success, error, message) => {
                    if (error) {
                      let errorMessage = message || 'User creation failed'
                      toastMessage(errorMessage, 'error')
                    } else {
                      toastMessage('User updated.', 'success')
                      setUserDialogVisibility(false)
                      setShowOtpUI(false)
                      setUserData(undefined)
                      let payload = {
                        pageNumber: page,
                        limit: limit
                      }
                      userFetch(payload)
                    }
                  })
                }
              }}
              onClose={() => {
                setUserDialogVisibility(false)
                setShowOtpUI(false)
                setUserData(undefined)
              }}
              onMobileEdit={() => {
                setShowEditMobileDialog(true)
              }}
            />
          </div>
        </Grid>
      </Grid>
      <Divider sx={{ marginTop: 5 }} />

      {userFetchloading && <UserTypeShimmer />}

      {userFetchError ? (
        <ErrorScreen
          onClick={() => {
            fetchUsersOnError()
          }}
        />
      ) : (
        <div>
          {!userFetchloading && userFetchData.data?.length <= 0 && (
            <ShowNoRecordsFound />
          )}
          {!userFetchError &&
            !userFetchloading &&
            userFetchData.data?.length > 0 && (
              <Grid container spacing={10} sx={{ paddingTop: 5 }}>
                <Grid item xs sm md>
                  <Box sx={{ margin: 2 }}>
                    <Card raised sx={{ borderRadius: 3 }}>
                      <CardContent>
                        <Grid
                          container
                          columns={6}
                          rowSpacing={3}
                          columnSpacing={3}
                        >
                          {userFetchData.data?.map((row, index) => (
                            <Grid item xs={6} sm={3} md={2} key={index}>
                              <UsersListUI users={row} />
                            </Grid>
                          ))}
                        </Grid>
                      </CardContent>
                      {pagecount > 1 && (
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2,
                            p: 2,
                            backgroundColor: 'grey.50',
                            borderRadius: 1
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'center',
                              width: '100%'
                            }}
                          >
                            <Pagination
                              count={pagecount}
                              page={page}
                              color="secondary"
                              size="small"
                              showFirstButton
                              showLastButton
                              onChange={handlePageChange}
                              sx={{
                                '& .MuiPaginationItem-root': {
                                  transition: 'all 0.2s ease-in-out'
                                }
                              }}
                            />
                          </Box>
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              gap: 1.5,
                              backgroundColor: 'white',
                              p: 2,
                              borderRadius: 1,
                              boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                              transition: 'box-shadow 0.2s ease-in-out',
                              '&:hover': {
                                boxShadow: '0 2px 6px rgba(0,0,0,0.12)'
                              }
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{ color: 'text.secondary', fontWeight: 500 }}
                            >
                              Jump to
                            </Typography>
                            <TextField
                              size="small"
                              value={goToPageInput}
                              onChange={handleGoToPageChange}
                              onKeyPress={handleGoToPageKeyPress}
                              placeholder="Page"
                              sx={{
                                width: '80px',
                                '& .MuiOutlinedInput-root': {
                                  backgroundColor: 'white',
                                  transition: 'all 0.2s ease-in-out',
                                  '& fieldset': {
                                    borderColor: 'grey.300',
                                    borderWidth: '1px'
                                  },
                                  '&:hover fieldset': {
                                    borderColor: 'secondary.main',
                                    borderWidth: '1.5px'
                                  },
                                  '&.Mui-focused fieldset': {
                                    borderColor: 'secondary.main',
                                    borderWidth: '2px',
                                    boxShadow:
                                      '0 0 0 3px rgba(156, 39, 176, 0.1)'
                                  }
                                },
                                '& .MuiOutlinedInput-input': {
                                  textAlign: 'center',
                                  fontWeight: 500,
                                  padding: '7px 8px',
                                  height: '20px',
                                  lineHeight: '20px'
                                }
                              }}
                            />
                            <Typography
                              variant="body2"
                              sx={{ color: 'text.secondary', fontWeight: 400 }}
                            >
                              of {pagecount}
                            </Typography>
                            <Button
                              variant="contained"
                              color="secondary"
                              size="small"
                              onClick={handleGoToPageSubmit}
                              disabled={
                                !goToPageInput ||
                                parseInt(goToPageInput, 10) < 1 ||
                                parseInt(goToPageInput, 10) > pagecount
                              }
                              sx={{
                                textTransform: 'none',
                                fontWeight: 500,
                                px: 2,
                                py: 0.75,
                                height: '34px',
                                lineHeight: 1,
                                transition: 'all 0.2s ease-in-out',
                                '&:hover': {
                                  transform: 'translateY(-1px)',
                                  boxShadow: '0 4px 8px rgba(156, 39, 176, 0.3)'
                                },
                                '&:active': {
                                  transform: 'translateY(0)'
                                }
                              }}
                            >
                              Go
                            </Button>
                          </Box>
                        </Box>
                      )}
                    </Card>
                  </Box>
                </Grid>
              </Grid>
            )}
          <UserInfoDialog
            visible={userInfoDialogVisibility}
            initialValues={_.cloneDeep(userdata)}
            title="User Info"
            closeText="Close"
            onClose={() => {
              setUserInfoDialogVisibility(false)
            }}
          />
          <EditMobileDialog
            visibility={showEditMobileDialog}
            showOtpUI={showOtpUI}
            onClose={() => {
              setShowEditMobileDialog(false)
              setShowOtpUI(false)
            }}
            onBackClick={() => {
              setShowOtpUI(false)
            }}
            onResendOTP={(mobile) => {
              sendOTP(mobile)
            }}
            onSubmit={async (value) => {
              let values = _.cloneDeep(value)
              if (!showOtpUI) {
                sendOTP(values.mobile)
              } else {
                if (values.OTP.length < 4) return

                let payload = {
                  mobile: values.mobile,
                  otp: values.OTP
                }
                await userVerifyAdminOtp(
                  payload,
                  async (success, error, message) => {
                    if (error) {
                      toastMessage(message, 'error')
                      return
                    } else {
                      let dummyUserdata = _.cloneDeep(userdata)
                      dummyUserdata.id = dummyUserdata._id
                      delete dummyUserdata.confirmPassword
                      delete dummyUserdata.password
                      delete dummyUserdata._id
                      delete dummyUserdata.key
                      dummyUserdata.mobile = values.mobile
                      dummyUserdata.outlet = dummyUserdata.outlet.map(
                        (item) => item._id
                      )
                      await userUpdate(
                        dummyUserdata,
                        (success, error, message) => {
                          if (error) {
                            let errorMessage =
                              message?.error?.message ||
                              'Mobile number update failed'

                            toastMessage(errorMessage, 'error')
                            setShowOtpUI(false)
                          } else {
                            toastMessage('Mobile number updated.', 'success')
                            setShowEditMobileDialog(false)
                            setShowOtpUI(false)
                            setUserDialogVisibility(false)
                            let payload = {
                              pageNumber: page,
                              limit: limit
                            }
                            userFetch(payload)
                          }
                        }
                      )
                    }
                  }
                )
              }
            }}
          />
        </div>
      )}

      <Snackbar
        open={snackbar}
        autoHideDuration={SnackBarHideDuration}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        onClose={handleSnackbarClose}
        TransitionComponent={SnackBarTransition}
      >
        <Alert onClose={handleSnackbarClose} severity={severity}>
          {PopUpMessage}
        </Alert>
      </Snackbar>
    </>
  )
}

export default FranchiseUsers
